import { createContext } from "react";
import { IReactFlowStateContext } from "../constants";

const ReactFlowStateContext = createContext<IReactFlowStateContext | undefined>(
    undefined
);

export default ReactFlowStateContext;
